import React from 'react';
import { Link } from 'react-router-dom';
// i18n çeviri fonksiyonu
import { useTranslation } from 'react-i18next';

const BlogSidebar = (props) => {
    const { t } = useTranslation();

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };
    const SubmitHandler = (e) => {
        e.preventDefault();
    };

    return (
        <div className="col-lg-4 mb-30">
            <div className="sidebarLayout">
                {/* Direct Contact */}
                <div className="innerWrapperSidebar mb-30">
                    <div className="sidebarWidget">
                        <div className="sidebarTitle">
                            <h5 className="sidebarTitle__heading text-uppercase mb-30">{t("blog_sidebar.direct_contact")}</h5>
                        </div>
                        <form className="sidebarContacts" onSubmit={SubmitHandler}>
                            <input type="text" className="sidebarContacts__input" placeholder={t("blog_sidebar.name_placeholder")} />
                            <input type="email" className="sidebarContacts__input" placeholder={t("blog_sidebar.email_placeholder")} />
                            <textarea className="sidebarContacts__input textarea" name="message" id="message" placeholder={t("blog_sidebar.message_placeholder")}></textarea>
                            <button className="btn btn--styleOne btn--primary it-btn" type='submit'>
                                <span className="btn__text">{t("blog_sidebar.send_message")}</span>
                                {/* ...SVG... */}
                            </button>
                        </form>
                    </div>
                </div>
                {/* Contact Info */}
                <div className="innerWrapperSidebar mb-30">
                    <div className="sidebarWidget">
                        <div className="sidebarTitle">
                            <h5 className="sidebarTitle__heading text-uppercase mb-30">{t("blog_sidebar.contact_info")}</h5>
                        </div>
                        <div className="sidebarContact">
                            <ul>
                                <li>
                                    <span>{t("blog_sidebar.address")} :</span>
                                    Üngüt Mahallesi 71069. Sokak Loft apartmanı kat:1 no:1 Onikişubat/Kahramanmaraş
                                </li>
                                <li>
                                    <span>{t("blog_sidebar.mail")} :</span>
                                    info@kaed.org.tr
                                </li>
                                <li>
                                    <span>{t("blog_sidebar.phone")} :</span>
                                    +90 554 515 90 95
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                {/* Popular Tag */}
                <div className="innerWrapperSidebar mb-30">
                    <div className="sidebarWidget">
                        <div className="sidebarTitle">
                            <h5 className="sidebarTitle__heading text-uppercase mb-30">{t("blog_sidebar.popular_tag")}</h5>
                        </div>
                        <div className="sidebarTags">
                            <ul>
                                <li><Link onClick={ClickHandler} to="/blog">{t("tags.education")}</Link></li>
                                <li><Link onClick={ClickHandler} to="/blog">{t("tags.charity")}</Link></li>
                                <li><Link onClick={ClickHandler} to="/blog">{t("tags.apps")}</Link></li>
                                <li><Link onClick={ClickHandler} to="/blog">{t("tags.education_build")}</Link></li>
                                <li><Link onClick={ClickHandler} to="/blog">{t("tags.data")}</Link></li>
                                <li><Link onClick={ClickHandler} to="/blog">{t("tags.book")}</Link></li>
                                <li><Link onClick={ClickHandler} to="/blog">{t("tags.design")}</Link></li>
                                <li><Link onClick={ClickHandler} to="/blog">{t("tags.website")}</Link></li>
                                <li><Link onClick={ClickHandler} to="/blog">{t("tags.landing_page")}</Link></li>
                                <li><Link onClick={ClickHandler} to="/blog">{t("tags.data")}</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogSidebar;
